import {useContext, useEffect, useRef, useState} from 'react';
import {ImageLayerInterface} from '../types/images-layer';
import {LayoutContext} from '../context/Layout';
import Konva from 'konva';
import {ResponseVehicle} from '../types/api';
import useImagesMoveTop from './use-images-move-top';
import useImagesVisualToggle from './use-images-visual-toggle';

const useImagesLayer = (
  vehicles: ResponseVehicle[],
  img1: HTMLImageElement | undefined,
  img2: HTMLImageElement | undefined,
  img3: HTMLImageElement | undefined
) => {
  const firstImageRef = useRef<Konva.Image | null>(null);
  const secondImageRef = useRef<Konva.Image | null>(null);
  const thirdImageRef = useRef<Konva.Image | null>(null);

  const {columnCount: columns} = useContext(LayoutContext);

  const [imagesLayer, setImagesLayers] = useState<ImageLayerInterface[] | null>(
    null
  );

  useImagesMoveTop(vehicles, firstImageRef, secondImageRef, thirdImageRef);

  useImagesVisualToggle(imagesLayer);

  useEffect(() => {
    if (!img1) return;

    // assign index to id
    img1.id = '0';

    if(img2) {
      img2.id = '1';
    }

    if(img3) {
      img3.id = '2';
    }

    let imagesArray: HTMLImageElement[] = [img3!, img2!, img1];

    if (columns < 3) imagesArray.splice(0, 1);

    const imagesLayerValues = imagesArray.filter(img => img).map((img) => {
      let imageRef = firstImageRef!;

      if (img.id == '1') {
        imageRef = secondImageRef;
      } else if (img.id == '2') {
        imageRef = thirdImageRef;
      }

      return {
        vehicle: vehicles[Number(img.id)],
        img,
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        imageRef
      };
    });

    setImagesLayers(imagesLayerValues);
  }, [img1, img2, img3, columns]);

  return imagesLayer;
};

export default useImagesLayer;
